import React from 'react';
import { Result, Typography } from '@duxton-web/ui';

type OverlayMessagePosition = 'center' | 'top';

const Overlay = ({
  title,
  subTitle,
  showOverlay,
  messagePosition = 'center',
  zIndex = 1000,
}: {
  title?: string;
  subTitle?: string;
  showOverlay?: boolean;
  messagePosition?: OverlayMessagePosition;
  zIndex?: number;
}) => {
  if (!showOverlay) return null;

  const isTopMessage = messagePosition === 'top';

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex,
        borderRadius: 14,
        display: 'flex',
        alignItems: isTopMessage ? 'flex-start' : 'center',
        boxSizing: 'border-box',
        justifyContent: 'center',
        paddingTop: isTopMessage ? 32 : 0,
      }}
    >
      <Result
        status="error"
        title={
          <Typography.Title level={2} style={{ color: 'white' }}>
            {title ? title : 'Editing Disallowed'}
          </Typography.Title>
        }
        subTitle={
          <Typography.Text style={{ color: 'white' }}>
            {subTitle
              ? subTitle
              : 'Editing of treatments is not allowed in current state.'}
          </Typography.Text>
        }
      />
    </div>
  );
};

export default Overlay;
